<template>
  <div class="transfer">
    <!-- 可选框区域 -->
    <div class="block-left">
        <div class="table-header">
            <div class="left">
                <el-checkbox :value="selectNoAdd.length>0 && selectNoAdd.length==optionalTableData.length" @change="changeSelectNoAdd">未添加挖机型号（{{selectNoAdd.length}}项）</el-checkbox>
            </div>
            <div class="right">
                <el-input v-model="noAddmachineCode" @keyup.enter.native="getCompanymachineNot">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="getCompanymachineNot"></i>
                </el-input>
            </div>
        </div>
      <el-table
        ref="optional"
        :data="optionalTableData"
        height="100%"
        @selection-change="changeOptional"
      >
        <el-table-column type="selection" width="80px"> </el-table-column>
        <el-table-column
          v-for="item in tableColumn"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
        >
        </el-table-column>
      </el-table>
    </div>

    <!-- 按钮上下穿梭区域 -->
    <div class="btns">
      <el-button
        type="primary"
        icon="el-icon-arrow-left"
        :disabled="selectAdd.length == 0"
        style="margin-bottom: 10px; width: 32px; height: 32px"
        @click="transferFn('down')"
      ></el-button>
      <el-button
        type="primary"
        icon="el-icon-arrow-right"
        :disabled="selectNoAdd.length == 0"
        style="margin: 0; width: 32px; height: 32px"
        @click="transferFn('up')"
      ></el-button>
    </div>

    <div class="block-right">
      <div class="table-header">
            <div class="left">
                <el-checkbox :value="selectAdd.length>0 && selectAdd.length==selectedTableData.length" @change="changeSelectAdd">已添加挖机型号（{{selectAdd.length}}项）</el-checkbox>
            </div>
            <div class="right">
                <el-input v-model="addmachineCode" @keyup.enter.native="getCompanymachineIn">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="getCompanymachineIn"></i>
                </el-input>
            </div>
        </div>
      <el-table
        ref="selected"
        :data="selectedTableData"
        height="100%"
        @selection-change="changeSelected"
      >
        <el-table-column type="selection" width="80px"></el-table-column>
        <el-table-column
          v-for="item in tableColumn"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- 已选框区域 -->
  </div>
</template>
<script>
import {
  getCompanymachine,
  batchAddProInModel,
  batchDelProInModel,
  updProInModelType,
  getProjectInfoExt,
} from "@/api/chain/projectinfo";
export default {
  name: "TransferTable",
  prop:['info'],
  data() {
    return {
      addmachineCode:"",
      noAddmachineCode:"",
      optionalTableData: [],
      selectedTableData: [],
      tableData: [],
      tableColumn: [
        {
          label: "挖机车主",
          prop: "ownerName",
        },
        {
          label: "挖机车主手机",
          prop: "ownerMobile",
        },
        {
          label: "机械型号",
          prop: "machineCode",
        },
      ],
      // info: {},
      selectNoAdd: [],
      selectAdd: [],
    };
  },
  mounted() {
    // this.info = JSON.parse(this.$route.query.info);
    this.getCompanymachineNot();
    this.getCompanymachineIn();
  },
  methods: {
    
    changeSelectNoAdd(val){
      if(val){
        this.$refs.optional.toggleAllSelection()
      }else{
        this.$refs.optional.clearSelection()
      }
    },
    changeSelectAdd(val){
      if(val){
        this.$refs.selected.toggleAllSelection()
      }else{
        this.$refs.selected.clearSelection()
      }
    },
    changeOptional(val) {
      this.selectNoAdd = val;
    },
    changeSelected(val) {
      this.selectAdd = val;
    },
    getCompanymachineNot() {
      getCompanymachine({
        current: 1,
        size: 999,
        notProjectIds: this.info.id,
        keyWord:this.noAddmachineCode
      }).then((res) => {
        this.optionalTableData = res.data.data.records;
      });
    },
    getCompanymachineIn() {
      getCompanymachine({
        current: 1,
        size: 999,
        inProjectIds: this.info.id,
        keyWord:this.addmachineCode
      }).then((res) => {
        this.selectedTableData = res.data.data.records;
      });
    },
    // 点击上下穿梭逻辑
    transferFn(type) {
      let selectRecords = [];
      if (type === "up") {
        batchAddProInModel({
          inModel: this.$refs.optional.selection.map((v) => v.id).join(","),
          projectInfoId: this.info.id,
        }).then((res) => {
          this.getCompanymachineNot();
          this.getCompanymachineIn();
        });
      } else {
        batchDelProInModel({
          inModel: this.$refs.selected.selection.map((v) => v.id).join(","),
          projectInfoId: this.info.id,
        }).then((res) => {
          this.getCompanymachineNot();
          this.getCompanymachineIn();
        });
      }
      if (!selectRecords.length) return;
      this.tableData.forEach((item) => {
        if (selectRecords.includes(item)) {
          item.showArea = type === "down" ? "selected" : "optional";
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/newPage.scss";
.block-left {
    width: 50%;
  border: 1px solid #ededf0;
}
.block-right {
    width: 50%;
  border: 1px solid #ededf0;
}
.transfer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btns {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  margin: 10px;
  /deep/.el-button.el-button--primary {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
  }
}
/deep/.el-button--primary.is-disabled {
  background: #ebedf0;
  border: #ebedf0;
  .el-icon-arrow-left {
    color: #bbbbbb;
  }
  .el-icon-arrow-right {
    color: #bbbbbb;
  }
  &:hover {
    background: #ebedf0;
    border: #ebedf0;
  }
}
.table-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
}
/deep/.el-table th.el-table__cell>.cell{
  padding-left: 24px!important;
}
/deep/.el-table-column--selection .cell{
  padding-left: 24px!important;
}
.block-left,.block-right{
    height: 100%;
  }
  .transfer{
    height: 100%;
  }
</style>
